<template>
	<div class="bit-page  page-padding-top">
    <top-bar :title="i18n.t('bit.title')"  @back="back"></top-bar>

    <div class="modal-page-main">
      <div class="sub-modal-title">{{i18n.t('bit.label1')}}</div>

      <div class="bit-list flex-wrap">
        <div class="list flex-center" v-for="(item, i) in bitList1" :key="i" :class="bitName == item.Name ? 'active' : ''" @click="changeBit(item)">
          <span>{{item.Name}}</span>
          <Icon color="#f7A600" name="success" v-if="bitName == item.Name"></Icon>
        </div>
      </div>

      <div class="sub-modal-title mt-20">{{i18n.t('bit.label2')}}</div>

      <div class="bit-list flex-wrap">
        <div class="list flex-center" v-for="(item, i) in bitList2" :key="i" :class="bitName == item.Name ? 'active' : ''" @click="changeBit(item)">
          <span>{{item.Name}}</span>
          <Icon color="#f7A600" name="success" v-if="bitName == item.Name"></Icon>
        </div>
      </div>
    </div>
	</div>
</template>
<script>
import { Icon } from 'vant'
import topBar from '@/components/topBar'
import { monetaryList } from '@/api/index'
export default {
  components: {
    topBar,
    Icon
  },
  data() {
		return {
			backUrl: require('../../assets/imgs/icon-back.png'),
      bitList1: [],
      bitList2: [],
      bitName: ''
		}
	},
  computed: {
    bitList() {
      return this.$store.state.bitList
     
    }
  },
  mounted() {
    this.init()
    this.bitName = localStorage.getItem('localCurrency') || 'USDT'
  },
	methods: {
    init() {
      monetaryList().then(res => {
        this.bitList2 = res.data.Items
        this.bitList1 = this.bitList2.slice(0, 3)
      })
    },
		back() {
			this.$router.go(-1)
		},
    changeBit(data) {
      this.bitName = data.Name
      localStorage.setItem('localCurrency', data.Name)
      this.$store.state.currencyVal = data.Name
      this.$store.state.currencyRate = data.Rate
      setTimeout(() => {
        this.back()
      }, 400)
    }
	}
}
</script>